import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import { ImagesMainBannerChristmas2024New } from '@/assets';
import { useRouter } from 'next/router';
import DefaultButton from '@/components/common/default/DefaultButton';
import {
  handleGooglePlayLink,
  handleAppleStoreLink,
} from '@/utilites/events.utils';

function ChristmasFirstSlider() {
  const { t: tMainbanner } = useTranslation('mainbanner');
  return (
    <div
      className="tw-flex tw-items-center tw-justify-between tw-relative tw-h-[390px] tw-rounded-[30px] col-12 tw-overflow-hidden max-nine:tw-rounded-none max-nine:tw-h-[320px]"
      style={{
        background:
          'linear-gradient(90deg, rgba(28,92,235,1) 57%, rgba(255,255,255,1) 100%)',
      }}
    >
      <div className="tw-flex tw-items-center tw-justify-between tw-basis-[40%] tw-h-full max-xl:tw-basis-2/4 max-nine:tw-basis-full max-nine:tw-justify-center max-nine:tw-px-4">
        <div className="tw-pl-[80px] tw-flex tw-gap-[20px] tw-flex-col tw-pt-[20px] tw-w-full max-nine:tw-pl-4 max-nine:tw-items-center max-nine:tw-text-center">
          <h2 className="tw-flex tw-flex-col tw-font-prata tw-text-white tw-text-5xl tw-m-0 tw-border-solid tw-border-4 tw-border-custom-gold tw-border-l-0 tw-border-t-0 tw-border-r-0 tw-pb-4 max-xl:tw-text-4xl max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-max-w-[300px] max-nine:tw-text-center max-nine:tw-border-b-0 max-nine:tw-relative">
            {tMainbanner('christmas_2024.special_deal')}
            <hr
              className="tw-hidden max-nine:tw-block max-nine:tw-absolute max-nine:tw-bottom-0 max-nine:tw-h-1 max-nine:tw-w-full max-nine:tw-bg-custom-gold max-nine:tw-rounded-full max-nine:tw-opacity-100 max-nine:tw-border-t-0 max-nine:tw-border-none max-nine:tw-m-0 max-nine:tw-p-0"
              aria-hidden="true"
            />
          </h2>
          <div className="max-nine:tw-flex max-nine:tw-flex-col max-nine:tw-items-center max-nine:tw-w-full">
            <div className="tw-w-fit max-nine:tw-w-full">
              <div
                className={
                  'tw-flex tw-gap-5 tw-font-light tw-justify-between tw-items-center max-nine:tw-flex-col max-nine:tw-gap-2'
                }
              >
                <p className="pt-2 tw-mb-0 tw-font-plusJakartaSans tw-text-white tw-font-light max-nine:tw-text-sm max-nine:tw-text-center">
                  The Balvenie 21 <br></br>PortWood
                </p>

                <p className="pt-2 tw-pb-0 tw-mb-0 tw-font-plusJakartaSans tw-text-white tw-font-bold max-nine:tw-text-sm max-nine:tw-text-center">
                  {tMainbanner('christmas_2024.glasses_for_free')}
                </p>
              </div>
              <div
                className={
                  'tw-flex tw-gap-5 tw-font-light tw-justify-between tw-items-center max-nine:tw-flex-col max-nine:tw-gap-2'
                }
              >
                <p className="pt-2 tw-mb-0 tw-font-plusJakartaSans tw-text-white tw-font-light max-nine:tw-text-sm max-nine:tw-text-center">
                  Glenfiddich 21 <br></br>Gran Reserva
                </p>

                <p className="pt-2 tw-pb-0 tw-mb-0 tw-font-plusJakartaSans tw-text-white tw-font-bold max-nine:tw-text-sm max-nine:tw-text-center">
                  {tMainbanner('christmas_2024.whisky_tumbler_for_free')}
                </p>
              </div>
            </div>
            <div className="tw-flex tw-items-center tw-gap-4 tw-pt-3 tw-justify-start max-nine:tw-flex-col max-nine:tw-w-full">
              <PrimaryButtonLink
                href={
                  '/glenfiddich-21-years-old-gran-reserva-2x-tumbler/spiritory'
                }
                className="tw-text-white tw-w-[50%] max-nine:tw-w-full max-nine:tw-px-6 max-nine:tw-text-sm"
                gold={true}
              >
                {tMainbanner('christmas_2024.buy_for')} 149€
              </PrimaryButtonLink>

              <PrimaryButtonLink
                href={'/balvenie-21-years-old-portwood-2x-glencairn/spiritory'}
                className="tw-w-[50%] max-nine:tw-w-full max-nine:tw-px-6 max-nine:tw-text-sm"
                white={true}
              >
                {tMainbanner('christmas_2024.buy_for')} 199€
              </PrimaryButtonLink>
            </div>
          </div>
        </div>
      </div>
      <div className="tw-basis-[40%] tw-pr-24 tw-relative max-nine:tw-hidden">
        <div className="tw-w-24 tw-h-24 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-white tw-absolute tw-left-4 tw-top-24 tw-bg-custom-gold tw-font-bold tw-text-xl max-onexl:tw-left-0 max-onexl:tw-top-20 max-xl:tw-top-16 max-xl:-tw-left-4">
          Only
          <br /> 149 €
        </div>
        <div className="tw-w-24 tw-h-24 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-white tw-absolute tw-right-[90px] tw-bottom-6 tw-bg-main tw-font-bold tw-text-xl max-onexl:tw-right-[80px] max-onexl:tw-bottom-2 max-xl:-tw-bottom-1 max-xl:tw-right-[50px]">
          Only
          <br /> 199 €
        </div>

        <Image
          src={
            ImagesMainBannerChristmas2024New.ImagesMainBannerChristmas2024NewSpecialDealsWebp
          }
          priority={true}
          alt="main banner background image"
          className="tw-relative tw-w-full tw-h-full tw-object-contain tw-rounded-[30px]"
        />
      </div>
    </div>
  );
}

function ChristmasSecondSlider({ userId }: { userId: string | null }) {
  const { t: tMainbanner } = useTranslation('mainbanner');
  const { locale } = useRouter();
  return (
    <div className="tw-flex tw-items-center tw-relative tw-h-[390px] tw-rounded-[30px] tw-justify-center col-12 max-nine:tw-rounded-none max-nine:tw-h-[320px]">
      <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-full max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-pl-[80px] tw-flex tw-gap-4 tw-flex-col tw-pt-[10px] tw-w-[50%] max-xl:tw-w-[55%] max-nine:tw-pl-4 max-nine:tw-pr-4 max-nine:tw-items-center max-nine:tw-text-center max-nine:tw-z-10 max-nine:tw-w-full">
          <div>
            <h2 className="tw-flex tw-flex-col tw-font-prata tw-text-main tw-text-5xl max-xl:tw-text-4xl max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-center max-nine:tw-text-white">
              {tMainbanner('christmas_2024.download_the_app')}
            </h2>
            <div>
              <div
                className={
                  'tw-flex tw-font-light tw-justify-center tw-flex-col'
                }
              >
                <b className="pt-2 tw-mb-0 tw-font-plusJakartaSans tw-font-bold max-nine:tw-text-sm max-nine:tw-text-center max-nine:tw-text-white">
                  {tMainbanner('christmas_2024.buy_sell_discover_fav_spirits')}
                </b>

                <p className="pt-2 tw-pb-0 tw-mb-0 tw-font-plusJakartaSans tw-font-medium max-nine:tw-text-sm max-nine:tw-text-center max-nine:tw-text-white">
                  {tMainbanner('christmas_2024.easily_manage')}
                </p>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-items-stretch child:tw-basis-2/4 tw-gap-8 child:tw-flex child:tw-items-center child:tw-gap-2 child:tw-bg-black child:tw-text-white child:tw-py-1 child:tw-px-5 child:tw-rounded-md max-nine:child:tw-w-full max-sm:tw-flex-col max-sm:tw-gap-4">
            <DefaultButton onClick={() => handleGooglePlayLink(userId, locale)}>
              <div>
                <Image
                  src={
                    ImagesMainBannerChristmas2024New.ImagesMainBannerChristmas2024NewGooglePlaySvg
                  }
                  alt="google play"
                  width={40}
                  height={40}
                />
              </div>
              <div className="tw-text-left">
                <p className="tw-m-0 tw-text-sm tw-font-bold">
                  {' '}
                  {tMainbanner('christmas_2024.android_app_on')}
                </p>
                <p className="tw-m-0 tw-text-lg tw-font-bold">Google Play</p>
              </div>
            </DefaultButton>
            <DefaultButton onClick={() => handleAppleStoreLink(userId, locale)}>
              <div>
                <Image
                  src={
                    ImagesMainBannerChristmas2024New.ImagesMainBannerChristmas2024NewAppleWhiteSvg
                  }
                  alt="app store"
                  width={40}
                  height={40}
                />
              </div>
              <div className="tw-text-left">
                <p className="tw-m-0 tw-text-sm">
                  {' '}
                  {tMainbanner('christmas_2024.download_on_the')}
                </p>
                <p className="tw-m-0 tw-font-bold tw-text-lg">
                  <b>App Store</b>
                </p>
              </div>
            </DefaultButton>
          </div>
        </div>
      </div>

      <Image
        src={
          ImagesMainBannerChristmas2024New.ImagesMainBannerChristmas2024NewDownloadTheAppWebp
        }
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-full tw-object-cover tw--z-10 tw-rounded-[30px] max-nine:tw-rounded-none"
      />
    </div>
  );
}

function ChristmasThirdSlider() {
  const { t: tMainbanner } = useTranslation('mainbanner');
  return (
    <div className="tw-flex tw-items-center tw-relative tw-h-[390px] tw-rounded-[30px] tw-justify-center col-12 max-nine:tw-rounded-none max-nine:tw-h-[320px]">
      <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-full max-nine:tw-justify-center">
        <div className="tw-pl-[80px] tw-flex tw-gap-4 tw-flex-col tw-pt-[10px] tw-w-3/5 max-nine:tw-w-full max-nine:tw-pl-4 max-nine:tw-pr-4 max-nine:tw-items-center max-nine:tw-text-center max-nine:tw-z-10">
          <h2 className="tw-flex tw-flex-col tw-font-prata tw-text-white tw-text-5xl tw-m-0 max-xl:tw-text-4xl max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-center">
            {tMainbanner('christmas_2024.bottles_of_the_month')}
          </h2>
          <div>
            <div
              className={
                'tw-flex tw-gap-5 tw-font-light tw-justify-between tw-items-center'
              }
            >
              <p className="pt-2 tw-mb-0 tw-font-plusJakartaSans tw-text-white tw-font-light max-nine:tw-text-sm max-nine:tw-text-center">
                {tMainbanner('christmas_2024.take_a_look')}
              </p>
            </div>

            <PrimaryButtonLink
              href={'/collections/whisky-zu-weihnachten-top-10'}
              className="tw-w-[50%] tw-mt-5 max-nine:tw-w-full max-nine:tw-px-6 max-nine:tw-text-sm"
              white={true}
            >
              {tMainbanner('christmas_2024.explore_our_collection')}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      <Image
        src={
          ImagesMainBannerChristmas2024New.ImagesMainBannerChristmas2024NewBottlesOfTheMonthWebp
        }
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-full tw-object-cover tw--z-10 tw-rounded-[30px] max-nine:tw-rounded-none"
      />
    </div>
  );
}

function ChristmasFourthSlider() {
  const { t: tMainbanner } = useTranslation('mainbanner');
  return (
    <div className="tw-flex tw-items-center tw-relative tw-h-[390px] tw-rounded-[30px] tw-justify-center col-12 max-nine:tw-rounded-none max-nine:tw-h-[320px]">
      <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-full max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-ml-auto tw-flex tw-gap-4 tw-flex-col tw-pt-[10px] tw-w-[45%] tw-pr-24 max-xl:tw-pr-4 max-nine:tw-ml-0 max-nine:tw-pl-4 max-nine:tw-pr-4 max-nine:tw-items-center max-nine:tw-text-center max-nine:tw-z-10 max-nine:tw-w-full">
          <h2 className="tw-flex tw-flex-col tw-font-prata tw-text-gray-900 tw-text-5xl tw-m-0 tw-border-solid tw-border-4 tw-border-custom-gold tw-border-l-0 tw-border-t-0 tw-border-r-0 tw-pb-4 max-xl:tw-text-4xl max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-center max-nine:tw-border-b-0 max-nine:tw-relative max-nine:tw-text-white max-nine:tw-w-fit max-nine:tw-mx-auto">
            {tMainbanner('christmas_2024.sell_faster_than_ever')}
            <hr
              className="tw-hidden max-nine:tw-block max-nine:tw-absolute max-nine:tw-bottom-0 max-nine:tw-h-1 max-nine:tw-w-full max-nine:tw-bg-custom-gold max-nine:tw-rounded-full max-nine:tw-opacity-100 max-nine:tw-border-t-0 max-nine:tw-border-none max-nine:tw-m-0 max-nine:tw-p-0"
              aria-hidden="true"
            />
          </h2>
          <div className="max-nine:tw-w-full">
            <div
              className={'tw-flex tw-font-light tw-justify-center tw-flex-col'}
            >
              <ul className="max-nine:tw-text-sm max-nine:tw-text-white max-nine:tw-pl-0 max-nine:tw-list-none">
                <li>{tMainbanner('christmas_2024.create_offer')}</li>
                <li>{tMainbanner('christmas_2024.low_fees')}</li>
                <li>{tMainbanner('christmas_2024.risk_free_payout')}</li>
              </ul>
            </div>
            <PrimaryButtonLink
              href={'/search'}
              className="tw-w-[50%] tw-mt-5 max-nine:tw-px-6 max-nine:tw-text-sm max-nine:tw-max-w-44 max-nine:tw-mx-auto"
            >
              {tMainbanner('christmas_2024.sell_a_bottle')}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>

      <Image
        src={
          ImagesMainBannerChristmas2024New.ImagesMainBannerChristmas2024NewSellFasterThanEverWebp
        }
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-full tw-object-cover tw--z-10 tw-rounded-[30px] max-nine:tw-rounded-none"
      />
    </div>
  );
}

function ChristmasFifthSlider() {
  const { t: tMainbanner } = useTranslation('mainbanner');
  return (
    <div className="tw-flex tw-items-center tw-relative tw-h-[390px] tw-rounded-[30px] tw-justify-center col-12 max-nine:tw-rounded-none max-nine:tw-h-[320px]">
      <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-full max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-md:tw-backdrop-brightness-50">
        <div className="tw-pl-[80px] tw-mr-auto tw-flex tw-gap-4 tw-flex-col tw-pt-[10px] tw-w-[60%] max-md:tw-w-full tw-pr-24 max-nine:tw-mr-0 max-nine:tw-pl-4 max-nine:tw-pr-4 max-nine:tw-items-center max-nine:tw-text-center max-nine:tw-z-10">
          <h2 className="tw-flex tw-flex-col tw-font-prata tw-text-5xl tw-m-0 tw-text-[#10275a] tw-border-solid tw-border-4 tw-border-custom-gold tw-border-l-0 tw-border-t-0 tw-border-r-0 tw-pb-4 max-xl:tw-text-4xl tw-leading-[60px] max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-center max-nine:tw-border-b-0 max-nine:tw-relative max-nine:tw-text-white">
            {tMainbanner('christmas_2024.buy_or_sell')}
            <hr
              className="tw-hidden max-nine:tw-block max-nine:tw-absolute max-nine:tw-bottom-0 max-nine:tw-h-1 max-nine:tw-w-full max-nine:tw-bg-custom-gold max-nine:tw-rounded-full max-nine:tw-opacity-100 max-nine:tw-border-t-0 max-nine:tw-border-none max-nine:tw-m-0 max-nine:tw-p-0"
              aria-hidden="true"
            />
          </h2>
          <div>
            <div
              className={'tw-flex tw-font-light tw-justify-center tw-flex-col'}
            >
              <p className="pt-2 tw-mb-0 tw-font-plusJakartaSans tw-font-normal max-nine:!tw-text-sm max-nine:tw-text-white max-nine:tw-text-center">
                {tMainbanner('christmas_2024.ultimate_platform')}
              </p>
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-gap-4 tw-pt-3 tw-justify-start child:tw-min-w-32 child:tw-flex-grow max-nine:tw-flex-col max-nine:tw-w-full">
            <PrimaryButtonLink
              href={'/search'}
              className="tw-text-white tw-w-[50%] max-nine:tw-w-full max-nine:tw-px-6 max-nine:tw-text-sm max-nine:tw-max-w-44 max-nine:tw-mx-auto"
            >
              {tMainbanner('christmas_2024.start_now')}
            </PrimaryButtonLink>

            <PrimaryButtonLink
              href={'/buyer-guide'}
              className="tw-w-[50%] max-nine:tw-w-full max-nine:tw-px-6 max-nine:tw-text-sm max-nine:tw-max-w-44 max-nine:tw-mx-auto"
              white={true}
            >
              {tMainbanner('christmas_2024.how_it_works')}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>

      <Image
        src={
          ImagesMainBannerChristmas2024New.ImagesMainBannerChristmas2024NewBuyOrSellWhiskyAndSpiritsWebp
        }
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-full tw-object-cover tw--z-10 tw-rounded-[30px] max-nine:tw-rounded-none tw-object-center"
      />
    </div>
  );
}

export {
  ChristmasFirstSlider,
  ChristmasSecondSlider,
  ChristmasThirdSlider,
  ChristmasFourthSlider,
  ChristmasFifthSlider,
};
